import React from "react";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

import { useSelector, useDispatch } from "react-redux";

import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { Typography, Box, Stack, Paper, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { Link as RouterLink } from "react-router-dom";

import { FormProvider, RHFTextField } from "../../../components/hook-form";

import logo from "../../../logo.svg";
import {
  checksEmailExist,
  forgotPassword,
} from "../../../redux/features/authSlice";

const VerifyEmail = () => {
  const dispatch = useDispatch();
  const [onSuccess, setOnSuccess] = React.useState(false);

  const { t } = useTranslation();

  const {
    translate,
    auth: { loading },
  } = useSelector((state) => state);

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  const ResetSchema = Yup.object().shape({
    email: Yup.string()
      .email("Insira um e-mail válido")
      .required(t("emailRequired")),
  });

  const defaultValues = {
    email: "",
  };

  const methods = useForm({
    resolver: yupResolver(ResetSchema),
    defaultValues,
  });

  const { handleSubmit, setError } = methods;

  const onSubmit = async () => {
    const data = methods.getValues();
    dispatch(checksEmailExist(data.email))
      .unwrap()
      .then((res) => {
        setOnSuccess(true);
        dispatch(forgotPassword({ data }));
      })
      .catch((err) => {
        //console.log(err);
        setOnSuccess(false);
        setError("email", {
          type: "emailfail",
          message: t("pleaseEnterTheRegisteredEmail"),
        });
      });
  };

  const style = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <Stack sx={style}>
      <Box sx={{ textAlign: "center" }}>
        <Box mb={8} mt={2} pr={4}>
          <img src={logo} alt="Tomaládácá logotipo"></img>
        </Box>

        <Paper
          variant="outlined"
          sx={{ maxWidth: 550, padding: "16px", borderRadius: "10px" }}
        >
          {onSuccess === false ? (
            <>
              <Typography pb={2} fontWeight="400" variant="h1" fontSize= '18px !important'>
                {t("resetYourPassword")}
              </Typography>
              <Typography pb={4} textAlign={"start"} variant="h2" fontSize= '18px !important' fontWeight="400">
                {t("enterRegisteredEmail")}
              </Typography>

              <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                <Stack spacing={3} pb="30px">
                  <RHFTextField name="email" label={t("enterYourEmail")} />
                </Stack>
              <Box sx={{display: "flex",justifyContent: "space-between",alignItems: "center",flexDirection: "row"}}>
              <Button
                to="/"
                size="large"
                variant="contained"
                component={RouterLink}
                sx={{
                  textTransform:"none",
                  "&:hover": {
                    color: "#ffffff",
                  },
                  borderRadius:"4px"
                }}
              >
                {t("toGoBack")}
              </Button>
              <LoadingButton sx={{borderRadius:'4px' , width: "auto"}}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  loading={loading}
                >
                  {t("sendPasswordResetEmail")}
                </LoadingButton>
                
              </Box>
                
              </FormProvider>
            </>
          ) : (
            <>
              <Typography pb={4} fontWeight="400" variant="h3">
                {t("resetPasswordLinkMessage")}
              </Typography>
              <Button
                to="/"
                size="large"
                variant="contained"
                component={RouterLink}
                sx={{
                  textTransform:"none",
                  "&:hover": {
                    color: "#ffffff",
                  },
                  borderRadius:"4px"
                }}
              >
                {t("goToHome")}
              </Button>
            </>
          )}
        </Paper>
      </Box>
    </Stack>
  );
};

export default VerifyEmail;
